import { render, staticRenderFns } from "./NavigationForm.vue?vue&type=template&id=bf92d20a&"
import script from "./NavigationForm.vue?vue&type=script&lang=js&"
export * from "./NavigationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports